import script from "./form.vue?vue&type=script&lang=ts&setup=true"
export * from "./form.vue?vue&type=script&lang=ts&setup=true"

import "./form.vue?vue&type=style&index=0&id=422603b9&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-422603b9"]])

export default __exports__